import React, { useState, useEffect } from "react";
import PaginationComponent from "../../../components/PaginationComponent";
import QuestionTableItem from "../components/QuestionTableItem";

export default function PackageHistoryTable({ id = "" }) {
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  //   const pageCount = Math.ceil(packageHistory.length / pageSize);

  useEffect(() => {
    // if (id) getPackageHistory(id);
  }, [id]);

  const handleClick = (event, index) => {
    event.preventDefault();
    setCurrentPage(index);
  };

  return (
    <>
      <table className="table table-borderless ">
        <thead>
          <tr className=" ">
            <td className="">Action</td>
            <td className="">Time </td>
            <td className="">By</td>
          </tr>
        </thead>
        <tbody>
          {/* {packageHistory.length > 0 ? (
            packageHistory
              .slice()
              .sort(
                (a, b) =>
                  new Date(b.updated_at ? b.updated_at : b.created_at) -
                  new Date(a.updated_at ? a.updated_at : a.created_at)
              )
              .slice(currentPage * pageSize, (currentPage + 1) * pageSize)
              .map((x, i) => <QuestionTableItem data={x} key={i} />)
          ) : (
            <tr>
              <td className="text-center font-weight-bold" colSpan="7">
                {loading ? "loading..." : "No Hisory Found..."}
              </td>
            </tr>
          )} */}
        </tbody>
      </table>
      {/* {packageHistory.length > 0 && (
        <PaginationComponent
          handleClick={handleClick}
          currentPage={currentPage}
          pageCount={pageCount}
        />
      )} */}
    </>
  );
}
